"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const searchicon = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-searchicon` : '') + (description ? ` desc-searchicon` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-searchicon"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-searchicon"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M 3.269531 0.875 C 5.296875 -0.292969 7.789062 -0.292969 9.8125 0.875 C 11.835938 2.046875 13.085938 4.203125 13.085938 6.542969 C 13.085938 8.167969 12.492188 9.65625 11.507812 10.800781 L 15.855469 15.148438 C 16.046875 15.34375 16.046875 15.660156 15.855469 15.855469 C 15.675781 16.03125 15.398438 16.046875 15.203125 15.902344 L 15.144531 15.855469 L 10.800781 11.507812 C 9.65625 12.492188 8.167969 13.085938 6.542969 13.085938 C 2.929688 13.085938 0 10.15625 0 6.542969 C 0 4.203125 1.246094 2.046875 3.269531 0.875 Z M 9.3125 1.742188 C 7.597656 0.753906 5.484375 0.753906 3.769531 1.742188 C 2.054688 2.734375 1 4.5625 1 6.542969 C 1 9.601562 3.480469 12.085938 6.542969 12.085938 C 8 12.085938 9.324219 11.523438 10.316406 10.601562 L 10.46875 10.453125 C 11.464844 9.453125 12.085938 8.070312 12.085938 6.542969 C 12.085938 4.5625 11.027344 2.734375 9.3125 1.742188 Z M 9.3125 1.742188 ",
    fill: "#000000",
    id: "Base/Icons/UI/search",
    stroke: "none"
  }));
};
var _default = exports.default = searchicon;